import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import LazyImage from "../components/LazyImage";
import { useLocation } from "react-router-dom";

const Home = () => {
const location = useLocation(); 
  useEffect(() => {
  AOS.init({ duration: 1200, once: false });
  AOS.refresh();
}, [location.pathname]);

  // Hero slideshow images
  const heroImages = [
    "hero/hero1.jpg",
    "hero/hero2.jpg",
    "hero/hero3.jpg",    
    "hero/hero4.jpg",
    "hero/hero5.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const [fadeTransition, setFadeTransition] = useState(true);

  useEffect(() => {
  const interval = setInterval(() => {
    setFadeTransition(false); // Start fading out

    setTimeout(() => {
      setPrevIndex(currentIndex);
      setCurrentIndex((prev) => (prev + 1) % heroImages.length);
      setFadeTransition(true); // Fade in the next image + foreground
    }, 500); // Allow fade out to complete before swapping image
  }, 8000);

  return () => clearInterval(interval);
}, [currentIndex]);


  const currentHeroImage = heroImages[currentIndex];
  const previousHeroImage = prevIndex !== null ? heroImages[prevIndex] : null;
  

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Benecke Group",
    "url": "https://www.beneckegroup.com",
    "publisher": {
      "@type": "Organization",
      "name": "Benecke Group",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.beneckegroup.com/logo-benecke.png",
      },
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.beneckegroup.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
      <>
        <Helmet>
          <title>Welcome to Benecke Group | Stay · Rent · Dine</title>
          <meta
              name="description"
              content="Family-owned and proudly local — Benecke Group offers affordable accommodation, property rentals, and great food under one trusted name."
          />
          <meta
              name="keywords"
              content="Benecke Group, accommodation, Spur, RocoMamas, property rentals, self-catering, hotels, B&Bs, Secunda, Vaal Triangle"
          />
          <meta name="author" content="Benecke Group" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://www.beneckegroup.com" />
          <meta property="og:title" content="Benecke Group | Accommodation, Rentals & Dining" />
          <meta property="og:description" content="Explore family-owned hotels, self-catering stays, rental properties and restaurants — proudly local and affordable." />
          <meta property="og:image" content="https://www.beneckegroup.com/og-home.jpg" />
          <meta property="og:url" content="https://www.beneckegroup.com" />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Welcome to Benecke Group | Stay · Rent · Dine" />
          <meta name="twitter:description" content="Benecke Group provides affordable hospitality, property and dining in the Vaal and Secunda regions." />
          <meta name="twitter:image" content="https://www.beneckegroup.com/og-home.jpg" />
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Helmet>

          <div className="bg-[#F2F1F0] text-[#144E73] font-sans">
            {/* Hero Slideshow */}
            <section className="relative h-[80vh] sm:h-screen flex items-center justify-center text-center text-[#F2F1F0] overflow-hidden">
    {heroImages.map((image, index) => (
      <LazyImage
        key={index}
        src={image}
        alt="Hero Slide"
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out z-0 ${index === currentIndex ? "opacity-100" : "opacity-0"}`}
      />
    ))}

    <div className="absolute inset-0 bg-[#144E73] bg-opacity-80 z-10" />

    <div
      key={currentIndex} 
      className={`relative z-20 max-w-3xl px-4 text-white animate-fadeUp transition-opacity duration-1000 ease-in-out ${
        fadeTransition ? "opacity-100" : "opacity-0"
    }`}
>
      
    <h1 className="text-4xl sm:text-4xl md:text-6xl font-bold mb-4">
      Stay. Rent. Dine. All with Benecke Group.
    </h1>
    <p className="text-base sm:text-lg md:text-xl mb-6">
      Family-owned and proudly local, we offer affordable accommodation, property rentals, and great food — all under one name you can trust.
    </p>
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <Link to="/accommodation" className="bg-[#F29E38] text-[#023059] font-semibold px-6 py-3 rounded-full shadow hover:bg-opacity-90 transition">
        Book Accommodation
      </Link>
      <Link to="/properties" className="bg-[#F29E38] text-[#023059] font-semibold px-6 py-3 rounded-full shadow hover:bg-opacity-90 transition">
        View Properties
      </Link>
      <Link to="/dining" className="bg-[#F29E38] text-[#023059] font-semibold px-6 py-3 rounded-full shadow hover:bg-opacity-90 transition">
        Explore Dining
      </Link>
      </div>
  </div>
</section>

          {/* Stay Section */}
          <section className="relative overflow-hidden py-20" data-aos="fade-up">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center relative z-10">
              <div className="space-y-6">
                <h2 className="text-3xl md:text-5xl font-bold leading-tight">Stay Your Way...</h2>
                <p className="text-lg leading-relaxed">Whether you're relaxing after a long day or seeking a peaceful retreat, our accommodations offer comfort and convenience.</p>
                <Link to="/accommodation" className="inline-block bg-[#F29E38] text-[#023059] font-semibold px-6 py-3 rounded-full shadow hover:bg-opacity-90 transition">Explore Stays</Link>
              </div>
              <div className="relative w-full h-[400px] md:h-auto rounded-lg overflow-hidden shadow-lg">
                <LazyImage src="/vaal_river.jpg" alt="Vaal River" />
                <div className="absolute inset-0 bg-[#144E73] bg-opacity-0" />
              </div>
            </div>
          </section>

          {/* Dining Section */}
          <section className="relative bg-[#144E73] text-[#F2F1F0] overflow-hidden pt-32 pb-20" data-aos="fade-up">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center relative z-10">
              <div className="relative w-full h-[400px] md:h-auto rounded-lg overflow-hidden shadow-lg order-1 md:order-none bg-white flex items-center justify-center">
                <LazyImage src="/spur.jpg" alt="Dining at Spur" className="p-4 object-contain" />
              </div>
              <div className="space-y-6">
                <h2 className="text-3xl md:text-5xl font-bold leading-tight">Come Dine with Us...</h2>
                <p className="text-lg leading-relaxed">Hearty breakfasts, family dinners, and casual get-togethers — we’ve got it all.</p>
                <Link to="/dining" className="inline-block bg-[#F29E38] text-[#023059] font-semibold px-6 py-3 rounded-full shadow hover:bg-opacity-90 transition">View Restaurants</Link>
              </div>
            </div>
          </section>  

          {/* Properties Section */}
          <section className="relative overflow-hidden pt-20 pb-20" data-aos="fade-up">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center relative z-0">
              <div className="space-y-6">
                <h2 className="text-3xl md:text-5xl font-bold leading-tight">Your Next Residential/Commercial Rental...</h2>
                <p className="text-lg leading-relaxed">Shops, homes, warehouses — we offer flexible rental options at fair prices.</p>
                <Link to="/properties" className="inline-block bg-[#F29E38] text-[#023059] font-semibold px-6 py-3 rounded-full shadow hover:bg-opacity-90 transition">View Properties</Link>
              </div>
              <div className="relative w-full h-[400px] md:h-auto rounded-lg overflow-hidden shadow-lg">
                <LazyImage src="/commercial_vpark.jpeg" alt="Commercial Property" />
              </div>
            </div>
          </section>

          {/* Services Grid */}
          <section className="py-20">
            <div className="max-w-6xl mx-auto px-6">
              <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-aos="fade-up">Take a Deeper Look</h2>
              <div className="grid md:grid-cols-3 gap-8" data-aos="fade-up" data-aos-delay="100">
                {[
                  {
                    title: 'Hotels & B&Bs',
                    desc: 'Comfortable, affordable stays...',
                    image: '/hotels.jpg',
                    linkText: 'Book Now',
                    linkTo: '/accommodation?filter=Hotel'
                  },
                  {
                    title: 'Self-Catering Accommodation',
                    desc: 'Perfect for long-term stays...',
                    image: '/self-catering.png',
                    linkText: 'View Options',
                    linkTo: '/accommodation?filter=Self-Catering'
                  },
                  {
                    title: 'Residential & Commercial Rentals',
                    desc: 'Explore affordable property rentals...',
                    image: '/rentals.jpg',
                    linkText: 'View Properties',
                    linkTo: '/properties'
                  },
                ].map((item, idx) => (
                    <div key={idx} className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col">
                      <div className="relative h-64 overflow-hidden">
                        <LazyImage
                          src={item.image}
                          alt={item.title}
                          className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-[#144E73] bg-opacity-30" />
                      </div>
                      <div className="p-6 flex flex-col flex-grow">
                        <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                        <p className="mb-4 flex-grow">{item.desc}</p>
                        <Link to={item.linkTo} className="mt-auto inline-block bg-[#F29E38] text-[#023059] font-semibold px-4 py-2 rounded-full shadow hover:bg-opacity-90 transition">{item.linkText}</Link>
                      </div>
                    </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </>
  );
};

export default Home;
